// This will format the CamelCase enum values by adding spacies between the words.
// For instance ValidEnumValue will result in Valid Enum Value
export const formatEnumValueWithSpaces = <T>(enumValue: T): string =>
    String(enumValue)
        .replace(/([A-Z])/g, " $1")
        .trim();
